import React, { useState } from 'react';
import { InputProps } from '../../types';
import { useTranslation } from 'react-i18next';

interface Option {
    value: string | number;
    label: string;
}

interface ExtendedInputProps extends InputProps {
    options?: Option[];
}

const Input = ({ type, name, text, value, onChange, required, disabled, options }: ExtendedInputProps) => {
    const { t, i18n } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === "password";
    const isSelect = type === "select";

    const inputType = isPassword
        ? (showPassword ? "text" : "password")
        : type;

    return (
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            <div className="relative w-full flex flex-col gap-2">
                <label htmlFor={name} className="font-medium text-lg">
                    {text}
                </label>
                <div className="relative">
                    {isSelect ? (
                        <select
                            id={name}
                            value={value}
                            onChange={onChange}
                            required={required}
                            disabled={disabled}
                            className="border w-full h-full border-grayColor rounded-lg px-2 py-3 bg-white focus:outline-none"
                        >

                            {options?.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type={inputType}
                            id={name}
                            value={value}
                            onChange={onChange}
                            required={required}
                            disabled={disabled}
                            autoComplete={isPassword ? "current-password" : "on"}
                            inputMode={isPassword ? "text" : undefined}
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck="false"
                            className="border w-full h-full border-grayColor rounded-lg px-2 py-3 bg-white focus:outline-none"
                           
                        />
                    )}
                    {isPassword && value && (
                        <span
                            onClick={() => setShowPassword((prev) => !prev)}
                            className={`absolute top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 ${i18n.language === "ar" ? "left-2" : "right-2"
                                }`}
                        >
                            {showPassword ? t("hide") : t("show")}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Input;
